/**
 * TGH Senior Center — Google Maps integration
 * Initialize Google Map with location markers and sync with locations list
 *
 * Locations data is loaded from #tgh-locations-data JSON on the page
 * (generated from WordPress admin)
 */

(function () {
  'use strict';

  var locations = {};
  var locationsList = [];

  function loadLocationsFromPage() {
    var scriptEl = document.getElementById('tgh-locations-data');
    if (!scriptEl) {
      console.warn('TGHMap: No locations data found on page (#tgh-locations-data)');
      return false;
    }

    try {
      var data = JSON.parse(scriptEl.textContent);
      if (!data.locations || !Array.isArray(data.locations)) {
        console.warn('TGHMap: Invalid locations data format');
        return false;
      }

      locationsList = data.locations;

      // Convert array to keyed object for backward compatibility
      data.locations.forEach(function (loc) {
        locations[loc.slug] = {
          slug: loc.slug,
          name: loc.name,
          lat: loc.lat,
          lng: loc.lng,
          address: loc.address,
          phone: loc.phone
        };
      });

      return true;
    } catch (error) {
      console.error('TGHMap: Error parsing locations JSON:', error);
      return false;
    }
  }

  var mapInstance = null;
  var markers = {};
  var infoWindows = {};

  function initMap() {
    var mapElement = document.getElementById('tgh-google-map');
    if (!mapElement) return;

    var center = { lat: 28.0, lng: -82.5 };

    mapInstance = new google.maps.Map(mapElement, {
      zoom: 10,
      center: center,
      styles: [
        {
          featureType: 'all',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#e8f4f8' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }]
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }]
        }
      ],
      mapTypeControl: false,
      streetViewControl: false
    });

    createMarkers();
  }

  function createMarkers() {
    var markerIcon = {
      path: 'M 0, 0 C -2.2, -2.2 -3.5, -3.5 -3.5, -5.5 C -3.5, -8.4 -1.7, -10 0, -10 C 1.7, -10 3.5, -8.4 3.5, -5.5 C 3.5, -3.5 2.2, -2.2 0, 0 Z',
      scale: 2,
      fillColor: '#FF6B6B',
      fillOpacity: 1,
      strokeColor: '#FFFFFF',
      strokeWeight: 2,
      anchor: new google.maps.Point(0, 0)
    };

    Object.keys(locations).forEach(function (key) {
      var loc = locations[key];

      var marker = new google.maps.Marker({
        position: { lat: loc.lat, lng: loc.lng },
        map: mapInstance,
        title: loc.name,
        icon: markerIcon
      });

      var infoWindowContent =
        '<div style="font-family: Arial, sans-serif; width: 250px;">' +
        '<h3 style="margin: 0 0 10px 0; font-size: 16px;">' + loc.name + '</h3>' +
        '<p style="margin: 5px 0; font-size: 12px;"><strong>Address:</strong><br>' + loc.address + '</p>' +
        '<p style="margin: 5px 0; font-size: 12px;"><strong>Phone:</strong> <a href="tel:+1' + loc.phone.replace(/\D/g, '') + '">' + loc.phone + '</a></p>' +
        '</div>';

      var infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });

      markers[key] = marker;
      infoWindows[key] = infoWindow;

      marker.addListener('click', function () {
        openInfoWindow(key);
        scrollToLocation(key);
      });
    });
  }

  function openInfoWindow(slug) {
    Object.keys(infoWindows).forEach(function (key) {
      infoWindows[key].close();
    });
    if (markers[slug] && infoWindows[slug]) {
      infoWindows[slug].open(mapInstance, markers[slug]);
    }
  }

  function closeAllInfoWindows() {
    Object.keys(infoWindows).forEach(function (key) {
      infoWindows[key].close();
    });
  }

  function scrollToLocation(slug) {
    var element = document.getElementById('tgh-loc-' + slug);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function setMarkerActive(slug) {
    Object.keys(markers).forEach(function (key) {
      var marker = markers[key];
      var scale = key === slug ? 2.5 : 2;
      marker.setIcon({
        path: 'M 0, 0 C -2.2, -2.2 -3.5, -3.5 -3.5, -5.5 C -3.5, -8.4 -1.7, -10 0, -10 C 1.7, -10 3.5, -8.4 3.5, -5.5 C 3.5, -3.5 2.2, -2.2 0, 0 Z',
        scale: scale,
        fillColor: key === slug ? '#FF6B6B' : '#FF6B6B',
        fillOpacity: key === slug ? 1 : 0.7,
        strokeColor: '#FFFFFF',
        strokeWeight: 2,
        anchor: new google.maps.Point(0, 0)
      });

      if (key === slug) {
        openInfoWindow(slug);
      }
    });
  }

  function setMarkerInactive() {
    Object.keys(markers).forEach(function (key) {
      markers[key].setIcon({
        path: 'M 0, 0 C -2.2, -2.2 -3.5, -3.5 -3.5, -5.5 C -3.5, -8.4 -1.7, -10 0, -10 C 1.7, -10 3.5, -8.4 3.5, -5.5 C 3.5, -3.5 2.2, -2.2 0, 0 Z',
        scale: 2,
        fillColor: '#FF6B6B',
        fillOpacity: 1,
        strokeColor: '#FFFFFF',
        strokeWeight: 2,
        anchor: new google.maps.Point(0, 0)
      });
    });
    closeAllInfoWindows();
  }

  function hideMarker(slug) {
    if (markers[slug]) {
      markers[slug].setVisible(false);
    }
  }

  function showMarker(slug) {
    if (markers[slug]) {
      markers[slug].setVisible(true);
    }
  }

  function geocodeAddress(address, callback) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        var lat = results[0].geometry.location.lat();
        var lng = results[0].geometry.location.lng();
        callback(null, { lat: lat, lng: lng });
      } else {
        callback(new Error('Geocoding failed: ' + status));
      }
    });
  }

  function getDistances(origin, destinations, callback) {
    var service = new google.maps.DistanceMatrixService();
    var destCoords = [];
    Object.keys(destinations).forEach(function (key) {
      destCoords.push(new google.maps.LatLng(destinations[key].lat, destinations[key].lng));
    });

    service.getDistanceMatrix({
      origins: [new google.maps.LatLng(origin.lat, origin.lng)],
      destinations: destCoords,
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.IMPERIAL
    }, function (response, status) {
      if (status === google.maps.DistanceMatrixStatus.OK) {
        callback(null, response);
      } else {
        callback(new Error('Distance Matrix failed: ' + status));
      }
    });
  }

  function init() {
    if (!loadLocationsFromPage()) {
      console.error('TGHMap: Failed to load locations, map will not initialize');
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMap);
    } else {
      initMap();
    }
  }

  var TGHMapAPI = {
    setMarkerActive: setMarkerActive,
    setMarkerInactive: setMarkerInactive,
    hideMarker: hideMarker,
    showMarker: showMarker,
    getLocationBySlug: function (slug) {
      return locations[slug];
    },
    getAllLocations: function () {
      return locations;
    },
    geocodeAddress: geocodeAddress,
    getDistances: getDistances,
    panTo: function (lat, lng, zoom) {
      if (mapInstance) {
        mapInstance.setCenter({ lat: lat, lng: lng });
        if (zoom) mapInstance.setZoom(zoom);
      }
    }
  };

  // Export to window for global access
  window.TGHMap = TGHMapAPI;

  init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/google-map.js